import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../store/store";
import { Button, message, Popconfirm, Tooltip } from "antd";
import { IconTrash } from "@tabler/icons-react";
import { useAPI } from "../../hooks/useAPI";
import { ENDPOINTS } from "../../constants/endpoints.constant";
import { deleteCall, updateCall } from "../../constants/apicalls.constant";
import { EventData, EventDetails, TicketData } from "../../models/event";
import { setSelectedEventList } from "../../store/slices/event.slice";
import DeleteModal from "../../components/DeleteModal";
const DeleteTicket = ({ id }: { eventID: string; id: string }) => {
  const { error, loading, trigger } = useAPI<{
    status: boolean;
    message: string;
    data: EventData;
  }>(ENDPOINTS.get_tickets);

  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const event = useSelector((state: RootState) => state.event);

  const buildUpdatedEvent = (
    event: EventData,
    updated_tickets: TicketData[] | undefined,
    updated_children?: EventDetails[],
  ): EventData => {
    const steps_info =
      updated_tickets && updated_tickets.length > 0
        ? event.steps_info
        : event?.steps_info?.filter((data) => data !== "ticket_config");

    return {
      ...event,
      tickets: updated_tickets,
      children: updated_children,
      steps_info,
    };
  };
  const onDelete = async () => {
    const res = await trigger(deleteCall(id!, { event_id: event.id }));

    if (!res?.status) {
      message.error(res?.message);
      return;
    }

    let updatedEvent: EventData;

    const updated_tickets = event.tickets?.filter(({ id: i }) => i !== id);

    updatedEvent = buildUpdatedEvent(event, updated_tickets);

    dispatch(setSelectedEventList(updatedEvent));
    await trigger(updateCall(event.id!, updatedEvent, {}, ENDPOINTS.event));
    message.success("Event Deleted successfully");
  };

  if (error) return <>Something went wrong</>;
  return (
    <>
      <Tooltip title="Delete this ticket">
        <Popconfirm
          title="Are you sure you want to delete this ticket?"
          onConfirm={() => onDelete()}
          okText="Yes"
          cancelText="No"
        >
          <Button
            type="text"
            danger
            color="red"
            shape="circle"
            loading={loading}
            icon={<IconTrash size={18} />}
          />
        </Popconfirm>
      </Tooltip>
      <DeleteModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onDelete={onDelete}
        loading={loading}
      />
    </>
  );
};

export default DeleteTicket;
